import emoji from "react-easy-emoji";
import cui from "./assets/img/icons/common/cui.jpg";
import DevNation from "./assets/img/icons/common/devnation.jpg";
import freelancing from "./assets/img/icons/common/freelancing.jpg";
// *                                             Greetings
export const greetings = {
	name: "Muddasar Hussain",
	title:"Hi all, I'm Muddasar",
	description:"I'm a Full Stack Web Developer building web applications with Industry Experience using MERN Stack. I have experience working with Modern Tech and Stacks to impress my clients and to show my skills. My strategy is 'Speak Less Code More !'",
};

export const openSource = {
	githubUserName: "muddasir03",
};

export const contact = {};

// *                                               Social Links
export const socialLinks = {
	facebook:"https://www.facebook.com/mian.mudassar.37669/",
	twitter: "https://www.instagram.com/moodijan03/",
	github: "https://github.com/muddasir03",
	linkedin: "https://www.linkedin.com/in/muddasar-hussain-a67460200/",
	instagram:"https://www.instagram.com/moodijan03/",
};

// *                                                Skills Section
export const skillsSection = {
	title: "What I do",
	subTitle:
		"CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
	skills: [
		emoji(
			"⚡ Develop highly interactive Front end / User Interfaces for your web applications using React JS"
		),
		emoji(
			"⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"
		),
		emoji(
			"⚡ Build Full Highly Responsive and SEO based websites using MERN Stack"
		),
	],

	softwareSkills: [
		{
			skillName: "html-5",
			fontAwesomeClassname: "vscode-icons:file-type-html",
		},
		{
			skillName: "css3",
			fontAwesomeClassname: "vscode-icons:file-type-css",
		},
		{
			skillName: "sass",
			fontAwesomeClassname: "logos:sass",
		},
		{
			skillName: "JavaScript",
			fontAwesomeClassname: "logos:javascript",
		},
		{
			skillName: "TypeScript",
			fontAwesomeClassname: "logos:typescript-icon",
		},
		{
			skillName: "reactjs",
			fontAwesomeClassname: "vscode-icons:file-type-reactjs",
		},
		{
			skillName: "nodejs",
			fontAwesomeClassname: "logos:nodejs-icon",
		},
		{
			skillName: "npm",
			fontAwesomeClassname: "vscode-icons:file-type-npm",
		},
		{
			skillName: "sql-database",
			fontAwesomeClassname: "vscode-icons:file-type-sql",
		},
		{
			skillName: "mongoDB",
			fontAwesomeClassname: "vscode-icons:file-type-mongo",
		},
		{
			skillName: "firebase",
			fontAwesomeClassname: "logos:firebase",
		},
		{
			skillName: "git",
			fontAwesomeClassname: "logos:git-icon",
		},
		],
};

// *                                                  Education Section
export const educationInfo = [

	{
		schoolName: "COMSATS University Islamabad, Sahiwal Campus",
		subHeader: "Bachelor in Computer Science",
		duration: "September 2020 - July 2024",
		desc: "Building my skills and learning a lot about Programming.",
		descBullets: [
			"Learning core concepts of Python and JavaScript",
			"Building Concepts and Logics with Data Structures and Algorithms",
		],
	},
	{
		schoolName: "DevNation -Learning Platform for Web Developers",
		subHeader: "Full Stack Web Developer",
		duration: "May 2021 - November 2021",
		desc: "Becoming a Full Stack Web Developer with Modern Stacks",
		descBullets: [
			"Building Projects as a team and start my freelancing Career",
			"Meetup with Modern Developers for best Career Guidance and Support",
		],
	},
];

//*                                              Experience Section
export const experience = [
	{
		role: "Full-Stack Web Developer",
		company: "DevNation",
		companylogo:DevNation,
		date: "May 2021 – November 2021",
		descBullets:[ 
		"Working as a student first and learn modern stacks.",
		"Later on, start building projects with the team and gain experience.",
		"Working on Front-end and Web Designing",
	],
	},
	{
		role: "Team work on Projects",
		company: "CUI Software House",
		companylogo:cui,
		date: "September 2020 – July 2021",
		descBullets:[ 
		"Working as a student first and learn modern stacks.",
		"Later on, start building projects with the team and gain experience.",
		"Working on Front-end by using React JS",
		],
	},
	{
		role: "Projects For Clients",
		company: "Freelancing",
		companylogo:freelancing,
		date: "January 2021 – Onwards",
		descBullets:[ 
		"Grab Clients from freelancing sites and build Projects.",
		"Later on, start building projects with the team and gain experience.",
		"Working as a Full-Stack web developer.",
		],
	},
];
//*                                               Projects Section
export const projects = [
{
		name: "Netflix Clone using React JS ",
		desc: "Netflix Clone using React JS and Database.",
		link: "https://netflix-muddasar-hussain.netlify.app/",
		github: "https://github.com/muddasir03/Netflix-Clone-using-React-JS",
	},	
{
		name: "E-commerce Store",
		desc: "Building an Application like Online E-commerce Store.",
		link: "https://muddasar-hussain-ecommerce.netlify.app/",
		github: "https://github.com/muddasir03/E-Commerce-Website.",
	},	
{
		name: "Book Store",
		desc: "Building an Application like Online Book Store.",
		link: "https://muddasar-hussain-bookstore.netlify.app/",
		github: "https://github.com/muddasir03/Book-Store",
	},	
{
		name: "Tour and Travel",
		desc: "Building an Application for tourists guidance",
		link: "https://muddasar-hussain-tour-and-travel.netlify.app/",
		github: "https://github.com/muddasir03/Tour-and-Travel-",
	},	

];